import { render, staticRenderFns } from "./Vippage.vue?vue&type=template&id=00d46007&scoped=true&"
import script from "./Vippage.vue?vue&type=script&lang=js&"
export * from "./Vippage.vue?vue&type=script&lang=js&"
import style0 from "./Vippage.vue?vue&type=style&index=0&id=00d46007&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d46007",
  null
  
)

export default component.exports